__turbopack_context__.v({
  "loadingContainer": "loading-module-scss-module__tgWE-G__loadingContainer",
  "loadingSpinner": "loading-module-scss-module__tgWE-G__loadingSpinner",
});
